import React, { useEffect } from "react";
import { Box } from "@mui/material";
import Intro from "../components/FacialStetic/Intro";
import BodyAestheticsHero from "../components/FacialStetic/BodyAestheticsHero";

const CorporalStetic = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Box component="main">
      <Intro />
      <BodyAestheticsHero />
    </Box>
  );
};

export default CorporalStetic;